<template>
  <view class="c-button-group" :style="compStyle">
    <template v-for="(item, index) in itemList" :key="index">









      <view
        class="c-button-group__item"
        :class="[ButtonGroupStatus[(item.status as ButtonGroupStatus)]]"
        :style="getButtonItemStyle(item)"
        @tap.stop="handleItemClick(item)"
      >

        {{ item.text }}

        <button
          v-if="item.openType === 'share'"
          :id="item?.openTypeKey || 'friend'"
          class="c-open-type-button"
          open-type="share"
        />

        <auth :auth-confirm-callback="() => handleAuthConfirm(item)" />

        <count-down
          v-if="item.countDownConfig?.time"
          v-slot="slotProps"
          class="count-down"
          auto-start
          :end-stamp="item.countDownConfig.time"
          @end="item.countDownConfig.endCallback"
        >
          <count-down-content
            :prefix="item.countDownConfig?.prefix"
            :suffix="item.countDownConfig?.suffix"
            :day="slotProps.times.d"
            :hour="slotProps.times.h"
            :minute="slotProps.times.m"
            :second="slotProps.times.s"
          />
        </count-down>
      </view>
    </template>
  </view>
</template>

<script setup lang="ts">
import Auth from '@/components/auth/index.vue';
import CountDown from '@/components/count-down/index.vue';
import CountDownContent from '@/components/count-down/content.vue';
import { fetchAddCustomerSource } from '@/services';
import { ButtonGroupStatus } from '@/types';
import type { Comp } from '@/types/global-business';
import { computed, toRefs } from 'vue';
import { commonUtils } from '@/utils';

interface Props {
  itemList: Comp.ButtonGroupItem[];
  /** 外边距 */
  margins?: number[];
}
const props = withDefaults(defineProps<Props>(), {
  margins: () => [],
});
const { itemList, margins } = toRefs(props);

let throttleFlag = false;

const compStyle = computed(() => {
  let style: Record<string, {}> = {};

  if (margins.value.length) {
    style = {
      ...style,
      ...commonUtils.style.formatSpacing(margins.value, 'margin'),
    };
  }

  return style;
});

const handleAuthConfirm = (item: AnyObject) => {
  if (item?.customerSourceType) {
    fetchAddCustomerSource(item.customerSourceType, item.customerSourceValue);
  }
  handleItemClick(item);
};

const handleItemClick = (item: AnyObject) => {
  // 默认节流
  if (typeof item?.delayTime === 'undefined' || item?.delayTime > 0) {
    // 判断条件
    if (!throttleFlag) {
      throttleFlag = true;
      setTimeout(() => (throttleFlag = false), item?.delayTime ?? 1000);
      // 正常执行事件
      item?.onClick?.();
    }
  } else {
    item?.onClick?.();
  }
};

const getButtonItemStyle = (item: Comp.ButtonGroupItem) => {
  let _style = {};

  if (item.fontSize) {
    _style = {
      ..._style,
      'font-size': `${item.fontSize}rpx`,
      'line-height': `${item.fontSize}rpx`,
    };
  }

  if (item.size) {
    _style = {
      ..._style,
      width: `${item.size[0]}rpx`,
      height: item.size[1] ? `${item.size[1]}rpx` : `100%`,
      'border-radius': `${item.size[1]}rpx`,
    };
  } else {
    _style = {
      ..._style,
      flex: 1,
    };
  }

  return _style;
};
</script>

<style scoped lang="scss">
.c-button-group {
  display: flex;
  align-items: center;

  .c-button-group__item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 88rpx;
    border-radius: 88rpx;
    margin-right: 18rpx;

    &:last-child {
      margin-right: 0;
    }

    &.normal {
      color: $N5;
      border: 1px solid $N5;
    }

    &.normalA {
      color: $N7;
      border: 1px solid $N5;
    }

    &.active {
      color: $M1;
      border: 1px solid $M1;
    }

    &.activeFill {
      color: $W;
      background: $M1;
    }

    &.activeFillM4 {
      color: $W;
      background: $M4;
    }

    &.activeFillCart {
      color: $W;
      background: $CART;
    }

    &.disabled {
      color: $W;
      background: $N3;
    }

    &.errorFill {
      color: $W;
      background: $EC;
    }

    &.blindboxActivity {
      flex-direction: column;
      height: 96rpx;
      background: linear-gradient(180deg, #fc7194, #ee3d66);
      box-shadow: 0rpx 6rpx 20rpx 0rpx rgba(136, 46, 9, 0.31);
      color: $W;
      font-size: 42rpx;
      font-family: 'siyuan-bold';
    }

    &.blindboxHelp {
      flex-direction: column;
      height: 96rpx;
      background: linear-gradient(180deg, #ffffff 0%, #ffe1e9 100%);
      box-shadow: 0rpx 6rpx 20rpx 0rpx rgba(136, 46, 9, 0.31);
      color: $blindbox;
      font-size: 42rpx;
      font-family: 'siyuan-bold';
    }

    &.blindboxDisabled {
      flex-direction: column;
      height: 96rpx;
      background: $N3;
      box-shadow: 0rpx 6rpx 20rpx 0rpx rgba(136, 46, 9, 0.31);
      color: $W;
      font-size: 42rpx;
      font-family: 'siyuan-bold';
    }

    &.blindboxRecord {
      flex-direction: column;
      height: 88rpx;
      background: linear-gradient(180deg, #f35078 0%, $blindbox 100%);
      color: $W;
      font-size: 34rpx;
      font-family: 'siyuan-bold';
    }

    &.blindboxPlainA {
      font-size: 28rpx;
      font-family: 'siyuan';
      color: $blindbox;
      border: 1px solid $blindbox;
    }
  }

  .count-down {
    display: flex;
    align-items: center;
    margin-top: -12rpx;
    text-align: center;
    font-size: 22rpx;
    font-family: 'siyuan';
  }
}
</style>
